module.exports = __webpack_public_path__ + "img/jian05.ba217c66.png";